export default __webpack_public_path__ + "tennis-pre.png";